/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable prefer-const */
import {
  generateDays, generateFlightRequestSeo, generateMinFareRequestSeo, groupFlightByDate,
} from '@/components/RoutePage/SectionManager/utils';
import WrapperSection from './WrapperSection';
import { TSelectedDate } from '@/slices/calendar';
import { useRouter } from 'next/router';

// slices
import {
  TMinFareObj, TMinFareRequest,
  useLazyGetFlightByIdQuery, useLazyGetFlightDataQuery, useLazyGetFlightStatisticsQuery, useLazyGetFlightStatisticsSeoRoute2Query, useLazyGetFlightStatisticsSeoRouteQuery,
} from '@/slices/flightData/apis/flightDataApi';
import { resetSelectedContact } from '@/slices/passenger/slices/passengerSlice';
import { addFlight } from '@/slices/selectedFlight/slices/selectedFlightSlice';
// utils
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { pr } from '@/utils/pxToRem';
import { Stack } from '@mui/material';
import { format } from 'date-fns';
import { get, minBy, uniq } from 'lodash';
import moment from 'moment';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { CONTENT_SECTION } from '../constants';
import {
  IGroupedByFlightNameSeoRoute, ItemSeoRoute,
} from '../../../RoutePage/SectionManager/type';
import { addSeoResponse } from '@/slices/flightData/slices/flightDataSlice';
import { monthYears } from '@/utils/monthYears';
import { matchPriceOrDash } from '@/utils/matchPriceOrDash';
import { style } from '@/styles/globals';
import { TGenerateFlightCountRequest } from '@/utils/generateFlightRequest';
import { tetDays, TET_MONTH, TET_YEAR } from '@/utils/constants';
import { getMappingDatePriceData, getMappingDatePriceDataCalendar } from '@/components/RouteCompanyCityToCity/SectionManager';

const formatDate = (date: Date) => format(date, 'yyyy-MM-dd');

interface ISectionManager {
  sxWrapper?: {
    [key: string]: any
  },
  hasBorder?: boolean | undefined,
  data: any,
  idComponent: string | undefined,
  title: string | undefined,
  content?: {
    [key: string]: any
  },
  routeName: string,
  company: string,
  companySlug: string,
  startPointHome: any,
  toPointHome: any,
  routeCode: string,
  routeCodeReturn: string,
  onSearchFlight: (date: TSelectedDate) => void
}

function SectionManager(props: Partial<ISectionManager>) {
  const {
    sxWrapper, idComponent, routeName, toPointHome, routeCode, onSearchFlight, routeCodeReturn, startPointHome, company, companySlug,
  } = props;
  const router = useRouter();

  const [getFlightDepartById, { data: flightById }] = useLazyGetFlightByIdQuery();

  const startPointState = useAppSelector((state) => state.searchFlightForm.startPointHome);
  const toPointState = useAppSelector((state) => state.searchFlightForm.toPointHome);
  const startPoint = startPointState || startPointHome;
  const toPoint = toPointState || toPointHome;
  const dispatch = useAppDispatch();
  let [
    getFlightStatisticsSeoRoute,
    {
      isFetching: isFetchingStatisticsSeo,
      currentData: dataStatisticsSeo,
      error: errorStatisticsSeo,
    },
  ] = useLazyGetFlightStatisticsSeoRouteQuery();

  let [
    getFlightStatisticsSeoTetRoute,
    {
      isFetching: isFetchingStatisticsTetSeo,
      currentData: dataStatisticsTetSeo,
      error: errorStatisticsTetSeo,
    },
  ] = useLazyGetFlightStatisticsSeoRouteQuery();

  let [
    getFlightStatisticsSeoRoute2,
    {
      currentData: dataStatisticsSeoReturn,
    },
  ] = useLazyGetFlightStatisticsSeoRoute2Query();

  let [getFlightData, { data: flightResult }] = useLazyGetFlightDataQuery();

  let [getMinFare, { data: dataStatistics }] = useLazyGetFlightStatisticsQuery();
  const { passenger } = useAppSelector((state) => state.searchFlightForm);
  const [selectedDate, setSelectedDateState] = useState(moment().toISOString());

  const fromAirports = startPoint?.airports?.map((airport: any) => airport.airportCode) || [];
  const toAirports = toPoint?.airports?.map((airport: any) => airport.airportCode) || [];

  if (!startPointHome) {
    dataStatisticsSeo = {
      grouped_by_date: {},
      grouped_by_date_seo_company: {},
      grouped_by_flight_name_seo_route: {},
    };
    dataStatisticsSeoReturn = {
      grouped_by_date: {},
      grouped_by_date_seo_company: {},
      grouped_by_flight_name_seo_route: {},
    };
    dataStatistics = [];
    flightResult = [];
  }

  const days = generateDays({
    date: selectedDate,
    minDate: moment().toISOString(),
    maxDate: moment().add(30, 'days').toISOString(),
  });
  // const dataGroup = dataStatisticsSeo ? groupItemByDate(dataStatisticsSeo as any, routeCode as string) : null;
  const dataGroup = flightResult ? groupFlightByDate(flightResult as any) : null;
  const groupedByLlightNameSeoRoute: IGroupedByFlightNameSeoRoute | undefined = dataStatisticsSeo?.grouped_by_flight_name_seo_route;
  let dataObj = groupedByLlightNameSeoRoute && routeCode ? groupedByLlightNameSeoRoute[routeCode] : {} as ItemSeoRoute;

  const groupedByLlightNameSeoRoute2: IGroupedByFlightNameSeoRoute | undefined = dataStatisticsSeoReturn?.grouped_by_flight_name_seo_route;
  const dataObjReturn = groupedByLlightNameSeoRoute2 && routeCodeReturn ? groupedByLlightNameSeoRoute2[routeCodeReturn] : {} as ItemSeoRoute;
  dataObj = {
    ...dataObj,
    lowest_round_flight_price: (dataObj?.lowest_price || 0) + (get(dataObjReturn, 'lowest_price') || 0),
  };

  const daysInNewYears = getMappingDatePriceData(dataStatisticsTetSeo);
  const findDayNewYear = tetDays.find((day) => (day.monthVN === 1 && day.dayVN === 1));

  useEffect(() => {
    setTimeout(() => {
      dispatch(addSeoResponse(dataStatisticsSeo));
    });
  }, [dataStatisticsSeo]);

  useEffect(() => {
    if (!startPoint || !toPoint) {
      return;
    }
    const flightRequestObject = generateMinFareRequestSeo({
      fromDateStr: flightRequest.fromDate,
      toDateStr: flightRequest.toDate,
      startPoint,
      toPoint,
      passenger,
    });
    const flightRequestObjectReturn = generateMinFareRequestSeo({
      fromDateStr: flightRequest.fromDate,
      toDateStr: flightRequest.toDate,
      startPoint: toPoint,
      toPoint: startPoint,
      passenger,
    });
    const routeFlightRequestObject = generateFlightRequestSeo({
      fromDateStr: flightRequest.fromDate,
      startPoint,
      toPoint,
      passenger,
    });

    const flightRequestTetObject = generateMinFareRequestSeo({
      fromDateStr: new Date('2025-01-01').toISOString(),
      toDateStr: new Date('2025-01-31').toISOString(),
      startPoint,
      toPoint,
      passenger,
      // airline: companySlug,

    });
    getMinFare(flightRequestStatistics);
    getFlightData(routeFlightRequestObject);
    getFlightStatisticsSeoRoute(flightRequestObject);
    getFlightStatisticsSeoTetRoute(flightRequestTetObject);
    getFlightStatisticsSeoRoute2(flightRequestObjectReturn);
  }, [startPoint, toPoint]);

  useEffect(() => {
    if (daysInNewYears?.length) {
      daysInNewYears.forEach((element) => {
        getFlightData({
          from: fromAirports,
          to: toAirports,
          flight_class: 'PT',
          date: element?.dateStr || format(new Date(selectedDate), 'yyyy-MM-dd'),
        });
      });
    }
  }, [daysInNewYears?.length]);

  const handleSelectDate = (date: Date) => {
    setSelectedDateState(date.toISOString());
  };

  const flightRequest: TMinFareRequest = {
    from: fromAirports,
    to: toAirports,
    fromDate: days ? formatDate(days[0].date) : formatDate(new Date()),
    toDate: days ? formatDate(days[days.length - 1].date) : formatDate(new Date()),
    mode: 'flight',
  };

  const flightRequestStatistics: TGenerateFlightCountRequest = {
    from: fromAirports,
    to: toAirports,
    month_years: monthYears(),
    flight_class: 'PT',
    // disable_update_filter: 1,
  };

  useEffect(() => {
    if (flightById) {
      const from = startPoint?.airports[0]?.nameVn;
      const to = toPoint?.airports[0]?.nameVn;
      dispatch(addFlight(flightById));
      const stringParams = {
        from,
        to,
        date: {
          depart: flightById?.route?.departureDate ? flightById?.route?.departureDate : selectedDate,
        },
        passenger: {
          adt: 1,
          chd: 0,
          inf: 0,
        },
        seatClass: 'PT',
      };
      router.push(`/trip-detail?${qs.stringify(stringParams)}&flightId[depart]=${flightById?.idIndex}`);
    }
  }, [flightById]);

  const dayPriceObj: any = {};
  if (dataGroup) {
    days.forEach((item: any) => {
      const key = item.dateStr;
      const matchDate = dataGroup[key] ? minBy(dataGroup[key], 'total_price_adult') || {} : {} as any;
      item.minFare = matchPriceOrDash(!matchDate ? 0 : Math.round(matchDate.total_price_adult / 1000));
      item.time = matchDate ? matchDate.pickup_time : '';
      item.averageMinfare = matchDate ? matchDate.total_price_adult : '';
      item.airline = matchDate ? matchDate.airline : {};
      item.id = matchDate?.id;
      item.pickup_time = matchDate?.pickup_time;
      item.dropoff_time = matchDate?.dropoff_time;
      dayPriceObj[key] = matchDate ? matchDate.total_price_adult : '';
    });
  }

  let countTetResult = {};
  const dayPriceObjStatictis = {} as TMinFareObj;
  dataStatistics?.forEach((group, idx) => {
    Object.keys(group?.grouped_by_date).forEach((groupedDate) => {
      dayPriceObjStatictis[groupedDate] = group?.grouped_by_date[groupedDate].min_fare;
      const date = group.grouped_by_date && Object.keys(group.grouped_by_date)[0];
      const month = new Date(date).getMonth();
      const year = new Date(date).getFullYear();
      if (+month + 1 === TET_MONTH && +year === TET_YEAR) {
        if (dataStatistics?.[idx]) {
          countTetResult = dataStatistics[idx];
        }
      }
    });
  });

  if (!toPoint) return null;

  const handleSelectTrip = (item: any) => {
    if (item?.id) {
      getFlightDepartById({ id: item?.id });
    }
    dispatch(resetSelectedContact());
  };

  const airlinesInNewYears = uniq((daysInNewYears.filter((item) => !!item?.airline?.name).map((item) => item?.airline?.name) || []));
  const airlinesAll = uniq((days.filter((item) => !!item?.airline?.name).map((item) => item?.airline?.name) || []));

  const renderComponent = ({ section }: any) => {
    const Component = section.component;
    if (!Component) {
      return null;
    }
    return (
      <Component
        isLoading={isFetchingStatisticsTetSeo}
        days={days}
        isCompanyCityCity={companySlug !== ''}
        company={companySlug}
        startPoint={startPointHome}
        toPoint={toPointHome}
        daysInNewYears={daysInNewYears}
        selectedDate={selectedDate}
        handleSelectDate={handleSelectDate}
        isFetching={isFetchingStatisticsSeo}
        errorStatistics={errorStatisticsSeo}
        flightData={dataGroup}
        handleSelectTrip={handleSelectTrip}
        dayTetPriceObjs={getMappingDatePriceDataCalendar(countTetResult)}
        routeName={`${startPoint?.location} - ${toPoint?.location}`}
        dayPriceObj={dayPriceObj}
        dayPriceObjStatictis={dayPriceObjStatictis}
        dataObj={dataObj}
        onSearchFlight={onSearchFlight}
        airlines={section.isNewYear ? airlinesInNewYears : airlinesAll}
        findDayNewYear={findDayNewYear}
      />
    );
  };
  const contentArr = Object.values(CONTENT_SECTION) as any;
  return (
    <Stack
      sx={{
        ...sxWrapper,
        background: 'white',
      }}
      spacing={pr`32px`}
      id={idComponent}
    >
      {contentArr.map((section: any, index: number) => (
        <WrapperSection
          key={index.toString()}
          section={section}
          dataObj={dataObj}
          titleComponent={section.title.component}
          idComponent={section.id}
          airlines={airlinesAll}
          toPointHome={toPointHome}
          startPointHome={startPointHome}
          routeName={routeName}
          company={company}
          isHaveDivider={false}
        >
          {section?.isDivider && <div style={{
            width: '120%',
            height: '24px',
            background: style.color.white2,
            position: 'absolute',
            left: '-20px',
            top: '-20px',
          }}
          />}
          {renderComponent({ section })}
        </WrapperSection>
      ))}
    </Stack>
  );
}

export default React.memo(SectionManager);
